import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { UserAuthenticationService } from '../../services/user-authentication.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent implements OnInit {
  isUserAuthenticated = false;

  constructor(
    private messageService: MessageService,
    private userAuthenticationService: UserAuthenticationService,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    // Check if there's a token in the URL query params (for cross-domain navigation)
    const token = this.route.snapshot.queryParams['token'];

    if (token) {
      // Try to authenticate with the provided token
      const isValidToken = this.userAuthenticationService.validateTokenAndAuthenticate(token);

      if (isValidToken) {
        // Token is valid, redirect to the default page
        this.router.navigate(['/work-orders']);
        return;
      }
    }

    // No valid token found, show unauthorized message
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: this.translateService.instant('Unauthorized_Mesagge'),
      key: 'unauthorized',
      life: 3000,
    });

    this.isUserAuthenticated = this.userAuthenticationService.isUserAuthenticated;
  }
}
